export default __webpack_public_path__ + "static/media/40288.62e12787.jpg";